// extracted by mini-css-extract-plugin
export default {"storeItem":"store-summary_storeItem__gI5jr"};